import { forwardRef, Ref } from 'react';

import { Button as Btn } from './Button';
import { BUTTON_VARIANTS } from './constants';
import { ButtonNoVariantProps } from './types';

export const PrimaryButton = forwardRef(
  (props: ButtonNoVariantProps, ref: Ref<HTMLButtonElement>) => (
    <Btn variant={BUTTON_VARIANTS.PRIMARY} {...props} ref={ref} />
  ),
);
export const SecondaryButton = forwardRef(
  (props: ButtonNoVariantProps, ref: Ref<HTMLButtonElement>) => (
    <Btn variant={BUTTON_VARIANTS.SECONDARY} {...props} ref={ref} />
  ),
);
export const SecondaryDestructiveButton = (props: ButtonNoVariantProps) => (
  <Btn variant={BUTTON_VARIANTS.SECONDARYDESTRUCTIVE} {...props} />
);
export const GhostButton = (props: ButtonNoVariantProps) => (
  <Btn variant={BUTTON_VARIANTS.GHOST} {...props} />
);
export const GhostInfoButton = (props: ButtonNoVariantProps) => (
  <Btn variant={BUTTON_VARIANTS.GHOSTINFO} {...props} />
);
export const GhostSuccessButton = (props: ButtonNoVariantProps) => (
  <Btn variant={BUTTON_VARIANTS.GHOSTSUCCESS} {...props} />
);
export const GhostErrorButton = (props: ButtonNoVariantProps) => (
  <Btn variant={BUTTON_VARIANTS.GHOSTERROR} {...props} />
);
export const GhostWarningButton = (props: ButtonNoVariantProps) => (
  <Btn variant={BUTTON_VARIANTS.GHOSTWARNING} {...props} />
);
export const GhostInvertedButton = (props: ButtonNoVariantProps) => (
  <Btn variant={BUTTON_VARIANTS.GHOSTINVERTED} {...props} />
);
export const DestructiveButton = (props: ButtonNoVariantProps) => (
  <Btn variant={BUTTON_VARIANTS.DESTRUCTIVE} {...props} />
);

export const TextButton = (props: ButtonNoVariantProps) => (
  <Btn variant={BUTTON_VARIANTS.TEXT} {...props} />
);
